import { SVGProps, Ref, forwardRef } from 'react';

export const ShieldOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 14.058c-1.146-.34-2.395-1.324-3.195-2.441C3.951 10.424 3.4 9.032 3.4 7.318v-3.77L8 1.978l4.6 1.568v3.771a7.15 7.15 0 0 1-1.399 4.29C10.4 12.71 9.14 13.716 8 14.058m6-11.513L8 .5 2 2.545v4.773c0 2.046.667 3.717 1.667 5.114S6.333 15.159 8 15.5c1.667-.34 3.341-1.704 4.333-3.068A8.55 8.55 0 0 0 14 7.318z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ShieldOutlinedSize16Glyph.displayName = 'ShieldOutlinedSize16Glyph';
